<!-- 金融-点击打开页面 -->
<template>
  <div class="jr-view">
    <van-image width="100%" fit="contain" :src="bgurl" :show-loading="false"></van-image>
    <van-image @click="toURL('http://mudu.tv/live/watch/mobile?id=og9x5v1m')" class="btn-img" width="40%" fit="contain" :src="btnurl" :show-loading="false"></van-image>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';

export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data () {
    // 这里存放数据
    return {
      bgurl: 'https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/h5/jinrong/jropen.jpg',
      btnurl: 'https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/h5/jinrong/jropen-btn.png'
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    toURL(url) {
      window.location.href = url
    },
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {},
  beforeCreate () {}, // 生命周期 - 创建之前
  beforeMount () {}, // 生命周期 - 挂载之前
  beforeUpdate () {}, // 生命周期 - 更新之前
  updated () {}, // 生命周期 - 更新之后
  beforeDestroy () {}, // 生命周期 - 销毁之前
  destroyed () {}, // 生命周期 - 销毁完成
  activated () {} // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped>
.jr-view {
  max-width: 900px;
  margin: 0 auto;
  position: relative;
}
.btn-img {
  position: absolute;
  left: 50%;
  margin-left: -20%;
  bottom: 60px;
}
</style>
